const apiBaseUrl = import.meta.env.VITE_API_BASE_URL

export const error = async (resp: Response) => {
  const error = new Error(`${await resp.text()}`)
  error.name = `${resp.status}`
  return error
}

export default {
  token: () => `${apiBaseUrl}/api/auth/token`,
  profile: () => `${apiBaseUrl}/api/user/profile`,
  password: () => `${apiBaseUrl}/api/user/password`,
  aliStsToken: () => `${apiBaseUrl}/api/user/ali_sts_token`,

  allUsers: () => `${apiBaseUrl}/api/admin/users`,
  user: (id: number) => `${apiBaseUrl}/api/admin/users/${id}`,
  users: ({ page, pageSize }: { page: number; pageSize: number }) =>
    `${apiBaseUrl}/users/?page=${page}&pageSize=${pageSize}`,

  allReceivers: () => `${apiBaseUrl}/api/admin/receivers`,
  receiver: (id: number) => `${apiBaseUrl}/api/admin/receivers/${id}`,
  defaultReceiver: () => `${apiBaseUrl}/api/default_receiver`,
  defaultSequencingReceiver: () => `${apiBaseUrl}/api/default_sequencing_receiver`,

  allAgreements: () => `${apiBaseUrl}/api/admin/agreements`,
  agreement: (id: number) => `${apiBaseUrl}/api/admin/agreements/${id}`,
  allBills: () => `${apiBaseUrl}/api/admin/bills`,
  bills: (id: number) => `${apiBaseUrl}/api/admin/bills/${id}`,

  adminConfig: () => `${apiBaseUrl}/api/admin/config`,
  adminFinanceConfig: () => `${apiBaseUrl}/api/admin/finance_config`,
  config: () => `${apiBaseUrl}/api/config`,

  order: () => `${apiBaseUrl}/api/order`,
  projectWithToken: (id: number) => `${apiBaseUrl}/api/project/${id}`,
  allOpenProjects: () => `${apiBaseUrl}/api/user/projects`,
  allProjects: () => `${apiBaseUrl}/api/user/projects/all`,
  project: (id: number) => `${apiBaseUrl}/api/user/projects/${id}`,
  sampleSheetProject: (id: number) => `${apiBaseUrl}/api/user/projects/${id}/sample_sheet`,
  extractionProject: (id: number) => `${apiBaseUrl}/api/user/projects/${id}/extraction`,
  sampleQAProject: (id: number) => `${apiBaseUrl}/api/user/projects/${id}/qa`,
  libraryProject: (id: number) => `${apiBaseUrl}/api/user/projects/${id}/library`,
  qcProject: (id: number) => `${apiBaseUrl}/api/user/projects/${id}/qc`,
  sequencingProject: (id: number) => `${apiBaseUrl}/api/user/projects/${id}/sequencing`,
  sequencingOssFolder: (id: number) => `${apiBaseUrl}/api/user/projects/${id}/sequencing_oss_folder`,
  sequencingDataToken: (id: number) => `${apiBaseUrl}/api/user/projects/${id}/sequencing_data_token`,
  projects: ({ page, pageSize }: { page: number; pageSize: number }) =>
    `${apiBaseUrl}/projects/?page=${page}&pageSize=${pageSize}`,

  allMessages: () => `${apiBaseUrl}/api/user/messages`,
  message: (id: number) => `${apiBaseUrl}/api/user/messages/${id}`,
}
